import initializeComponent from 'Shared/react-initialize';
import { extendTheme } from '@chakra-ui/react';
import ChakraProviderScopedReset from 'Shared/chakra-provider';
import { theme } from '@carpenter/theme';
import { ComponentType } from 'react';

export const extendedTheme = extendTheme(theme);

export function Initializer<T>(Component: ComponentType<T>) {
   return (props: T) => (
      <ChakraProviderScopedReset theme={extendedTheme}>
         {/*
            // @ts-expect-error TS(2322): Type 'T' is not assignable to type 'IntrinsicAttributes & T'. */}
         <Component {...props} />
      </ChakraProviderScopedReset>
   );
}

export function initializeChakraComponent(name: any, Component: any, defaultProps = {}) {
   initializeComponent(name, Initializer(Component), defaultProps);
}
